// extracted by mini-css-extract-plugin
module.exports = {"module":"TelephoneInputField_module__XrTXC","label":"TelephoneInputField_label__2eBdo"};